import * as React from "react";
import type { SVGProps } from "react";
const SvgPdfFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#pdf-file_svg__a)">
      <path d="M20 22H4a1 1 0 0 1-1-1V7a1 1 0 0 1 .29-.71l4-4A1 1 0 0 1 8 2h12a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1M5 20h14V4H8.41L5 7.41z" />
      <path d="M8 8H4a1 1 0 0 1 0-2h3V3a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1M5.91 10.62H8.1c1.28 0 1.86.76 1.86 2v.49c0 1.36-.53 2.09-1.89 2.09h-.41V18H5.91zm1.75 3.17h.14c.29 0 .39-.14.39-.58v-.79c0-.4-.15-.5-.4-.5h-.13zM10.46 10.62h1.92c1.44 0 2.13.56 2.13 2.27v2.69c0 1.53-.39 2.37-1.88 2.37h-2.17zm1.75 6h.16c.27 0 .37-.15.37-.48v-3.73c0-.39-.14-.48-.38-.48h-.15zM15.06 10.62h3.23v1.44h-1.48v1.43h1.36v1.45h-1.36v3h-1.75z" />
    </g>
    <defs>
      <clipPath id="pdf-file_svg__a">
        <path fill="#fff" d="M3 2h18v20H3z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPdfFile;
